import React, { useState, useEffect } from 'react';
import RealProjectsThumb from './RealProjectsThumb'
import SideProjects from './SideProjects'
import Footer from './Footer'
import { ModeToggle } from '@/components/mode-toggle'
import Navigationbar from './utils/Navigationbar'
import { NavLink } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import MainStacks from './utils/MainStacks'
import Socials from './Socials'
import Domiciline from './utils/Domiciline'

export default function Contact() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    
    useEffect(() => {
        const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // Change the breakpoint as per your needs
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function to remove the event listener
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

//       const generateRandomString = (length) => {
//     const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//     return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
//   };

  // Generate 300 string acak
//   const randomParagraphs = Array.from({ length: 3600 }, (_, i) => (
//     <p key={i} className="text-sm hover:opacity-80">
//       {generateRandomString(1)} {/* ganti 8 kalau mau string lebih panjang */}
//     </p>
//   ));

  return (
    <div className='relative'>
        <section className='w-full'>
            <div className='container max-w-md mx-auto px-6 lg:px-0'>
                {/* <div className='mb-4 flex items-center justify-between gap-4'>
                    <NavLink to='/'>
                        <img src='/unaascii-xsm.png' className='w-12 block dark:hidden rounded-full' />
                        <img src='/unaascii-xsm-white.png' className='w-12 hidden dark:block rounded-full' />
                    </NavLink>
                    <Navigationbar />
                </div> */}
                <div className='flex flex-col gap-6 mb-6 pt-12 lg:pt-4'>
                    <div className='flex flex-col items-start justify-center mb-8'>
                        <p>Got projects in mind?</p>
                        {/* <p className='opacity-60 text-sm font-light'>Let's Connect Digitally</p> */}
                    </div>
                    {/* <div className='flex flex-col items-start justify-start gap-4'>
                        <p className='opacity-50'>Open to new freelance gigs, Let’s make it happen!</p>
                    </div> */}
                </div>
                {/* <div className='mt-6'>
                    <MainStacks />
                    <Footer />
                </div> */}
                <div className='space-y-8'>
                    <Domiciline />
                    <Socials />
                </div>
                <div className='flex items-center w-full justify-between gap-3 pt-4 pb-8'>
                    <Footer />
                    <ModeToggle />
                </div>
            </div>
            <Toaster />
        </section>
        {isMobile ? 
            <div/>
            : <div className='absolute top-0 opacity-[.07] dark:opacity-[.05] min-w-screen flex flex-wrap gap-2'>
            {/* {randomParagraphs} */}
        </div>
        }
    </div>
  )
}
